import { Fragment, useState } from 'react';
import { SocialMediaContainer, SocialMediaLinks, StyledSdfSelect, StyledSdfIcon } from './styles';
import { countries } from '../mocks/products.mock';
import { SdfSelectItem } from '@waypoint/react-components';
import { SOCIAL_LINKS as socialLinks } from '../../constants';
import { FooterNavigationBar, FooterStorefrontNavigation, FooterStorefrontNavigationCountryClick, sendGA4Data } from '../../analytics/events';
import { useSelector, useDispatch } from 'react-redux';
import { setCountryAndLocale } from '@headless-shell/store';
import { countryNavigateUrl } from '../../utils/helper';

const Socials = ({ navigate }) => {
  const country = useSelector(state => state.app.selectedCountry) || {};
  const dispatch = useDispatch();

const handleChange = (e) => {
  let localeValue = e?.target?.value?.value || '';
  dispatch(setCountryAndLocale({
    country: e?.target?.value?.label || '',
    locale:  e?.target?.value?.value
  }));
  const countryUrl = countryNavigateUrl({ localeValue });
  navigate(countryUrl);
  sendGA4Data(FooterStorefrontNavigationCountryClick, { eventLabel: localeValue });

  e.stopPropagation();
};

const handleSocialClick = (e, href, socialAlt) => {
  e.preventDefault();
  window.open(href, '_blank');

  sendGA4Data(FooterNavigationBar, { eventCategory: "Social", eventLabel: socialAlt });
};

const onCountryDropdownClick = (e) => {
  if(e.target.className?.includes("open")) return;
  sendGA4Data(FooterStorefrontNavigation);
}

  return (
    <Fragment>
      <SocialMediaContainer id="social-media-container">
        {socialLinks.map((social, i) => (
          <SocialMediaLinks
            id={`socialmedia-links-${i}`}
            key={i}
            label="social-media-links"
            onClick={(e) => handleSocialClick(e, social.href, social.alt)} 
          >
            <StyledSdfIcon icon={social.icon} size="lg" />
          </SocialMediaLinks>
        ))}
      </SocialMediaContainer>
      <StyledSdfSelect
        id="country-selector"
        placeholder={country}
        title="Select Country"
        onSdfChange={handleChange}
        onClick={onCountryDropdownClick}
      >
        {countries.map((country) => (
          <SdfSelectItem
            key={country.name}
            value={country.value}
          >
            {country.name}
          </SdfSelectItem>
        ))}
      </StyledSdfSelect>
    </Fragment>
  );
};

export default Socials;